import { appRoles, clientRoles } from '@alli/frontend-common';

export function userIsAdminOfAnyApplication(currentUser) {
    return (currentUser.applications || []).some(({ id }) =>
        appRoles.isGranted(id, appRoles.ADMIN, currentUser),
    );
}

// central ID is always the same, no need to do env variables
export const alliCentralId = '50af1d47-c264-4165-b047-52649e6609cc';

export function userCanManageClient(currentUser, client) {
    if (!client) {
        return false;
    }

    return (
        appRoles.isGranted(alliCentralId, appRoles.POWER, currentUser) ||
        clientRoles.isGranted(client.id, clientRoles.OWNER, currentUser)
    );
}
